import { getData, postData, putData, deleteData } from "../apiClient";

// Get booking commissions with pagination
export const getBookingCommissionsWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/booking-commission/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Booking Commissions with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// Get booking commission by ID
export const getBookingCommissionWithId = async (id) => {
    try {
        const result = await getData(`/booking-commission/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Booking Commission data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// Create booking commission
export const createBookingCommission = async (data) => {
    try {
        const result = await postData(`/booking-commission/`, data);

        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Booking Commission API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// Delete booking commission
export const deleteBookingCommission = async ({ id }) => {
    try {
        const result = await deleteData(`/booking-commission/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Booking Commission API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// Update booking commission
export const updateBookingCommission = async ({ id, data }) => {
    try {
        const result = await putData(`/booking-commission/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Update user API error:", error.data);
        return {
            data: {
                success: false,
                error: error.status === 400 ? (error.data?.errors || error.error) : error.message,
                status: error.status,
            },
        };
    }
};

// Get booking types for dropdown
export const getBookingTypes = async (signal = null) => {
    try {
        const result = await getData(`/booking-commission/booking-types/list`, {}, {}, signal);
        return {
            success: true,
            data: result,
        };
    } catch (error) {
        console.error("Get Booking Types API error:", error);
        return {
            success: false,
            error: error.message,
        };
    }
};
